import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/interactives/Tooltip'
import { toggleCollapsedGroupsAtom } from '@/store/rundown.store'
import { cn } from '@/utils'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSetAtom } from 'jotai'
import { useState } from 'react'

export function RundownHeaderCollapseGroupsToggle() {
  const [toggleStatus, setToggleStatus] = useState(true)
  const toggleCollapsedGroups = useSetAtom(toggleCollapsedGroupsAtom)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex-none w-full h-7 rounded-sm opacity-70 text-gray-500 group-hover:opacity-70 hover:opacity-100! transition-opacity text-xs focus:outline-hidden focus:ring-3"
          onClick={() => {
            toggleCollapsedGroups(toggleStatus)
            setToggleStatus(!toggleStatus)
          }}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            className={cn(['transition-all', toggleStatus ? '' : '-rotate-90'])}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent>
        {toggleStatus ? 'Collapse' : 'Expand'} all groups
      </TooltipContent>
    </Tooltip>
  )
}
